import creditVerificationFetcher from '../creditVerificationFetcher.js';
import icoFetcher from '../icoFetcher.js';
import getPath from './getPath.js';
import getPaymentCalculationFetcher from '../paymentCalculationFetcher.js';
import getPaymentIncentivesFetcher from '../paymentIncentivesFetcher.js';
import tradeInFetcher from '../tradeInFetcher.js';
import getDrSettingsFetcher from '../getDrSettingsFetcher.js';
import walletConfigFetcher from '../walletConfigFetcher.js';
function buildFetchers(environment) {
  // environment = prod or staging
  const path = getPath(environment); // takes a second, optional, argument defining hosts (default is: {prod: 'www.autotrader.com', staging: 'test.autotrader.com'})
  return {
    CreditVerificationFetcher: creditVerificationFetcher(path),
    WalletConfigFetcher: walletConfigFetcher(environment),
    DrSettingsFetcher: getDrSettingsFetcher(getPath, environment),
    IcoFetcher: icoFetcher(path),
    PaymentCalculationFetcher: getPaymentCalculationFetcher(path),
    PaymentIncentivesFetcher: getPaymentIncentivesFetcher(path),
    TradeInFetcher: tradeInFetcher(path)
  };
}
export { buildFetchers as default };
